import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { RouterModule } from '@angular/router';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzUploadModule } from 'ng-zorro-antd/upload';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzListModule } from 'ng-zorro-antd/list';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { NzTabsModule } from 'ng-zorro-antd/tabs';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { RuleEngineModule } from '../rule-engine/rule-engine.module';
import { CrudLyfisPartnerProfileComponent } from './crud-lyfis-partner-profile/crud-lyfis-partner-profile.component';
import { ManageLyfisPartnerProfileComponent } from './manage-lyfis-partner-profile/manage-lyfis-partner-profile.component';
import { ManageLyfisQuestionsComponent } from './manage-lyfis-questions/manage-lyfis-questions.component';
import { CrudLyfisQuestionComponent } from './crud-lyfis-question/crud-lyfis-question.component';
import { ScorecardCompilerComponent } from './scorecard-compiler/scorecard-compiler.component';
import { ScorecardCompilationsComponent } from './scorecard-compilations/scorecard-compilations.component';
import { LyfisTestingComponent } from './lyfis-testing/lyfis-testing.component';
import { LyfisTraceDetailComponent } from './lyfis-trace-detail/lyfis-trace-detail.component';
import { LyfisViewUsersComponent } from './lyfis-view-users/lyfis-view-users.component';
import { LyfisViewUserSnapshotsComponent } from './lyfis-view-user-snapshots/lyfis-view-user-snapshots.component';
import { LyfisViewSnapshotDiseasesComponent } from './lyfis-view-snapshot-diseases/lyfis-view-snapshot-diseases.component';
import { LyfisPersistedTraceDetailComponent } from './lyfis-persisted-trace-detail/lyfis-persisted-trace-detail.component';

@NgModule({
  declarations: [CrudLyfisPartnerProfileComponent, ManageLyfisPartnerProfileComponent, ManageLyfisQuestionsComponent, CrudLyfisQuestionComponent, ScorecardCompilerComponent, ScorecardCompilationsComponent, LyfisTestingComponent, LyfisTraceDetailComponent, LyfisViewUsersComponent, LyfisViewUserSnapshotsComponent, LyfisViewSnapshotDiseasesComponent, LyfisPersistedTraceDetailComponent],
  imports: [CommonModule, ReactiveFormsModule, NzIconModule, FormsModule, NzCollapseModule, NzTableModule, NzInputModule, NzButtonModule, NzSelectModule, NzCardModule, NzSwitchModule, NzTagModule, RouterModule, NzDividerModule, NzDropDownModule, NzCheckboxModule, NzDrawerModule, NzRadioModule, NzUploadModule, NzSpinModule, NzListModule, NzAlertModule, NzTabsModule, NzToolTipModule, RuleEngineModule],
})
export class LyfisModule { }

